module.exports = __webpack_public_path__ + "img/star-02.e3a60ad0.svg";